import React, { Component } from "react";
import Style from "./PreviewImage.module.css";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import Modal from "react-modal";

export default class PreviewImage extends Component {
  constructor(props) {
    super(props);
    console.log("Preview Image", this.props);
    this.state = {
      css:
        this.props.css ||
        "http://204.48.26.50:8039/api/media/download/599317d07dc545149f064541cc2e1e53.jpeg",
      certificateText: this.props.certificateText || "",
      isLandscape: true,
    };
    //tobe changed here
    this.convertToBase64(this.state.css, (base64) => {
      this.setState({
        css: base64,
      });
    });
  }

    convertToBase64 = (url, callback, outputFormat) => {
      var canvas = document.createElement("CANVAS");
      var ctx = canvas.getContext("2d");
      var img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        // Clean up
        canvas = null;
      };
      img.src = url;
    };

  toggleLayout = () => {
    const { isLandscape } = this.state;
    this.setState({
      isLandscape: !isLandscape,
    });
  };
  domToImage = () => {
    let node = document.getElementById("certi");
    domtoimage
      .toPng(node)
      .then((dataUrl) => {
        if (this.state.isLandscape) {
          const pdf = new jsPDF("l", "cm", "a4");
          pdf.addImage(dataUrl, "png", 0, 0);
          console.log(dataUrl);
          pdf.save("Certi.pdf");
        } else {
          const pdf = new jsPDF("p", "mm", "a4");
          pdf.addImage(dataUrl, "png", 0, 0);
          pdf.save("Certi.pdf");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  render() {
    console.log("style", Style.imageDiv);
    const landscape = `
    <div style="
    width:1090px;
    margin: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
    border: 30px solid transparent;
    border-image: url(${this.state.css}) 5% fill">
      <div>
        ${this.state.certificateText}
      </div>
    </div>
    `;
    const potrait = `
    <div style="
    height:1100px;
    width:790px;
    border: 30px solid transparent;
    border-image: url(${this.state.css}) 20% fill">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
      ${this.state.certificateText}
    </div>`;
    return (
      <div className="text-center">
        <Modal
          isOpen={this.props.isOpen}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.props.handleToggle}
          style={{
            overlay: {
              backgroundColor: "grey",
            },
            content: {
              color: "black",
            },
          }}
        >
          <div className="row justify-content-md-center">
            <div className="col col-lg-2" />
            <div id="certi" className="col-md-auto">
              {this.state.isLandscape ? (
                <div
                  className="text-center"
                  dangerouslySetInnerHTML={{
                    __html: landscape,
                  }}
                />
              ) : (
                <div
                  className="text-center"
                  dangerouslySetInnerHTML={{
                    __html: potrait,
                  }}
                />
              )}
              <br />
              <br />
              <br />
            </div>
            <div className="col col-lg-2" />
          </div>
          <div className="row">
            <button className="btn btn-info m-2" onClick={this.toggleLayout}>
              Toggle Layout
            </button>
            <button className="btn btn-primary m-2" onClick={this.domToImage}>
              Generate Certificate
            </button>
            <button
              className="btn btn-danger m-2"
              onClick={this.props.handleToggle}
            >
              Close Window
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
